(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
        const images = document.querySelectorAll('.lazy-image');
    
        const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            const img = entry.target;
    
            if (img.dataset.src) {
                img.src = img.dataset.src;
            }
    
            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
            }
    
            img.classList.add('loaded');
    
            obs.unobserve(img);
            }
        });
        }, {
        rootMargin: '200px 0px', // 🔥 control distance here
        threshold: 0.01
        });
    
        images.forEach(img => observer.observe(img));
    });
  } catch(e) { console.error(e); }
})();

})();
